import { render, staticRenderFns } from "./Bet.vue?vue&type=template&id=1a10425a&scoped=true"
import script from "./Bet.vue?vue&type=script&lang=js"
export * from "./Bet.vue?vue&type=script&lang=js"
import style0 from "./Bet.vue?vue&type=style&index=0&id=1a10425a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a10425a",
  null
  
)

export default component.exports